import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function DemoButton({ className = "btn-ghost px-4 py-2 text-sm font-semibold", testid = "try-demo-button", label = "Try Live Demo" }) {
  const { startDemo, user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (user && !user.demo) { nav(user.role === "customer" ? "/customer" : "/admin"); return; }
    setBusy(true);
    try { await startDemo(); toast.success("Demo workspace opened — all data is sample data"); nav("/customer"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not open the demo right now"); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testid} onClick={go} disabled={busy} className={`${className} inline-flex items-center justify-center gap-2 disabled:opacity-60`}>
      <FlaskConical size={15} /> {busy ? "Opening demo…" : label}
    </button>
  );
}
